import React from "react";
import { ShimmerDiv, ShimmerTitle } from "./ThemedShimmer";

/**
 * News feed / profile post list loading placeholder.
 */
const PostFeedSkeleton = ({ count = 1, className = "" }) => (
  <div
    className={`skeleton-post-stack ${className}`.trim()}
    role="status"
    aria-busy="true"
    aria-label="Loading posts"
  >
    <span className="skeleton-screen-reader-only">Loading posts</span>
    {Array.from({ length: count }, (_, index) => (
      <div className="mt-3 shimmer-cont skeleton-surface" key={`post-skeleton-${index}`}>
        <div className="shimmer-header d-flex align-items-center">
          <ShimmerDiv height={48} width={48} rounded={50} />
          <div className="shimmer-title ms-3">
            <ShimmerTitle line={2} gap={8} />
          </div>
        </div>
        <div className="square-shimmer mt-2 px-2 pb-2">
          <ShimmerDiv height={280} width="100%" />
        </div>
        <div className="d-flex gap-2 px-3 pb-3">
          <ShimmerDiv height={32} width={72} rounded={6} />
          <ShimmerDiv height={32} width={72} rounded={6} />
          <ShimmerDiv height={32} width={72} rounded={6} />
        </div>
      </div>
    ))}
  </div>
);

export default PostFeedSkeleton;
